import React, { useState } from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Box, Snackbar} from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import Alert from "@mui/material/Alert";
import LoadingButton from "@mui/lab/LoadingButton";

function VerifyClaimA({ data, claim_update_list, verifyClaim, Refresh }) {
    const [open, setOpen] = useState(false);
    const [claimCredit, setClaimCredit] = useState(0);
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success', // 可以是 'error', 'warning', 'info', 'success'
    });
    const openDialog = () => {
        let claim_credit = 0;
        if (claim_update_list && claim_update_list.length >= 1) {
            for (let i = 0; i < claim_update_list.length; i++) {
                for (let x = 0; x < data.length; x++) {
                    if (data[x].id === claim_update_list[i]) {
                        if (data[x].status === '1') {
                            if (!snackbar.open) setSnackbar({open: true, message: '无法对已确认的数据进行操作！', severity: 'error'});
                            return;
                        } else {
                            claim_credit += Number(data[x].Check_amount);
                            break;
                        }
                    }
                }
            }
            setOpen(true);
            setClaimCredit(claim_credit);
        } else {
            if (!snackbar.open) setSnackbar({open: true, message: '请勾选一项进行修改！', severity: 'error'});
        }
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            console.log(claim_update_list)
            const result = await verifyClaim("PUT", {ids: claim_update_list, status: 'verify'}, claim_update_list[0]);
            if (result?.status === 204) {
                setSnackbar({open: true, message: '确认索赔成功！', severity: 'success'});
                handleClose();
            }else {
                setSnackbar({open: false, message: '确认索赔失败！', severity: 'error'});
                handleClose();
            }
        } catch (e) {
            console.error("确认索赔失败", e);
        } finally {
            setLoading(false);
            Refresh()

        }
    };
    return (
        <span>
            <Button sx={{ textTransform: 'none' }} startIcon={<VerifiedIcon />} onClick={openDialog}>
                确认索赔
            </Button>
            <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
                <DialogTitle>确认索赔</DialogTitle>
                <DialogContent>
                    <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexWrap: 'wrap' }}>
                        <FormControl sx={{ m: 1, minWidth: 500 }}>
                            即将对此{claim_update_list.length}个数据进行确认
                            <br /><br /><br />
                            总确认额度: {claimCredit.toFixed(2)}
                        </FormControl>
                        <DialogActions>
                            <Button fullWidth variant="contained" sx={{ mt: 3, mb: 2, ml: 45 }} onClick={handleClose}>
                                取消
                            </Button>
                            <LoadingButton loading={loading} fullWidth type="submit" variant="contained" sx={{ mt: 3, mb: 2 }}>
                                确认
                            </LoadingButton>
                        </DialogActions>
                    </Box>
                </DialogContent>
            </Dialog>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </span>
    );
}
export default VerifyClaimA